module.exports = __webpack_public_path__ + "img/ImgC3.fae3fc92.jpeg";